// React Basic and Bootstrap
import React, { Component } from "react";

// Import Generic components
import Section from "./section";
import Services from "./Services";
import HowItWorks from "./HowItWorks";
import Price from "../Price";
import Faqs from "./Faq";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Section />
        <Services />
        <HowItWorks />
        <Faqs />
        <Price />
      </React.Fragment>
    );
  }
}

export default Index;
